
import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ErrorBoundary from './ErrorBoundary';
import App from './App';
import './index.css';
import { configureAmplifyAndStartDataStore } from './amplify-config';

// Polyfill for Node.js 'global' in browser
if (typeof global === 'undefined') {
  (window as any).global = window;
}

// Polyfill for crypto (required by DataStore)
if (typeof window !== 'undefined' && !window.crypto) {
  // Modern browsers have window.crypto, but ensure it's available
  if (!(window as any).crypto) {
    (window as any).crypto = {
      getRandomValues: (arr: any) => {
        // Fallback for older browsers
        for (let i = 0; i < arr.length; i++) {
          arr[i] = Math.floor(Math.random() * 256);
        }
        return arr;
      }
    };
  }
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

const rootElement = document.getElementById('root') as HTMLElement | null;
if (!rootElement) {
  throw new Error('Root element not found!');
}

async function main() {
  await configureAmplifyAndStartDataStore();

  ReactDOM.createRoot(rootElement!).render(
    <React.StrictMode>
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
          <App />
        </QueryClientProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}

main().catch(error => {
  console.error('❌ Error initializing app:', error);
  rootElement.innerHTML = `
    <div style="padding: 20px; font-family: Arial; background: #fff; min-height: 100vh;">
      <h1 style="color: red;">Error Loading Application</h1>
      <p>There was an error loading the application. Please check the browser console (F12) for details.</p>
      <pre style="background: #f5f5f5; padding: 10px; border-radius: 4px; overflow: auto;">${error?.message || String(error)}</pre>
    </div>
  `;
});
